export default "__VITE_ASSET__aaabd9ba__$_?nuxt_component=async__"